import { Controller } from "@hotwired/stimulus"
import { useClickOutside } from 'stimulus-use'

// Connects to data-controller="autocomplete"
export default class extends Controller {
  static targets = ["input", "list"]
  static values = { url: String, model: String, field: String, index: Number }

  connect() {
    useClickOutside(this)

    this.selectedIndex = -1
    this.listTarget.innerHTML = ""

    this.boundHandleKeydown = this.handleKeydown.bind(this)
    document.addEventListener("keydown", this.boundHandleKeydown)
  }

  disconnect() {
    document.removeEventListener("keydown", this.boundHandleKeydown)
  }

  clickOutside() {
    this.close()
  }

  async search() {
    const query = this.inputTarget.value.trim()

    const elementId = `order_order_infos_attributes_${this.indexValue}_item_id`
    const element = document.getElementById(elementId)

    let value

    if (element) {
      value = element.value
    } else {
      value = 0
    }

    if (query.length < 1) {
      this.close()
      return
    }

    const url = `${this.urlValue}?query=${encodeURIComponent(query)}&model=${this.modelValue}&field=${this.fieldValue}&item=${value}`

    try {
      const response = await fetch(url)
      const data = await response.json()
      this.renderResults(data)
    } catch (error) {
      console.error("Autocomplete error:", error)
      this.listTarget.innerHTML = "<li>Error fetching results</li>"
      this.listTarget.classList.add("autocomplete-results")
    }
  }

  onFocus() {
    const elementId = `order_order_infos_attributes_${this.indexValue}_item_id`
    const element = document.getElementById(elementId)

    let value

    if (element) {
      value = element.value
    } else {
      value = 0
    }

    const url = `${this.urlValue}?query=&model=${this.modelValue}&field=${this.fieldValue}&item=${value}`
    fetch(url)
      .then((response) => {
        if (!response.ok) {
          throw new Error("Network response was not ok")
        }
        return response.json()
      })
      .then((data) => {
        this.renderResults(data)
      })
      .catch((error) => {
        console.error("Autocomplete error:", error)
        this.listTarget.innerHTML = "<li>Error fetching results</li>"
        this.listTarget.classList.add("autocomplete-results")
      })
  }

  renderResults(data) {
    if (Array.isArray(data) && data.length > 0) {
      const field = this.fieldValue

      // 중복 제거
      const uniqueData = data.filter(
        (item, index, self) =>
          self.findIndex((t) => t[field] === item[field]) === index
      )

      // 결과 렌더링
      this.listTarget.innerHTML = uniqueData
        .map(
          (item, index) =>
            `<li data-index="${index}" class="autocomplete-item">${item[field]}</li>`
        )
        .join("")

      this.selectedIndex = -1
      this.listTarget.classList.add("autocomplete-results")
    } else {
      this.close()
    }
  }

  handleKeydown(event) {
    const items = Array.from(this.listTarget.querySelectorAll(".autocomplete-item"))
    if (items.length === 0) return

    if (event.key === "ArrowDown") {
      event.preventDefault()
      this.selectedIndex = (this.selectedIndex + 1) % items.length
      this.updateSelection(items)
    } else if (event.key === "ArrowUp") {
      event.preventDefault()
      this.selectedIndex = (this.selectedIndex - 1 + items.length) % items.length
      this.updateSelection(items)
    } else if (event.key === "Enter") {
      event.preventDefault()
      if (this.selectedIndex >= 0) {
        this.selectItem(items[this.selectedIndex])
      }
    }
  }

  updateSelection(items) {
    items.forEach((item, index) => {
      if (index === this.selectedIndex) {
        item.classList.add("selected")
        item.scrollIntoView({ block: "nearest" })
      } else {
        item.classList.remove("selected")
      }
    })
  }

  select(event) {
    this.selectItem(event.target)
  }

  selectItem(item) {
    this.inputTarget.value = item.textContent
    this.close()
  }

  close() {
    this.listTarget.classList.remove("autocomplete-results")
    this.listTarget.innerHTML = ""
    this.selectedIndex = -1
  }
}
